module.exports = __webpack_public_path__ + "img/btn-ticket-disable.e71d9d75.svg";